<template>
<div class="login">
  <Header></Header>
    <div class="login_wrapper">
      <div class="main">
        <h3>账户登录</h3>
        <el-form :model="loginForm" :rules="loginRules" ref="loginFormRefs" class="demo-loginForm">
          <el-form-item label="" prop="name">
            <el-input type="text" v-model="loginForm.userName" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item label="" prop="pass">
            <el-input type="password" v-model="loginForm.password" placeholder="密码"></el-input>
          </el-form-item>
        </el-form>
        <div class="login-oper">
          <p v-show="isError">{{ errMsg }}</p>
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
        </div>
      </div>
    </div>
  <Footer></Footer>
</div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import local from '../utils/local.js'
import { getrsa } from '../utils/rsas.js'
import { login } from '../api/loginApi.js'
export default {
  name: 'Login',
  components:{
    Header,
    Footer
  },
  data() {
    return {
      loginForm: {
        userName: '',
        password: '',
      },
      loginRules:{
        userName: [{ required: true, message: '请输入登录账号', trigger: 'blur'}],
        password: [{ required: true, message: '请输入登录密码', trigger: 'blur'}],
      },
			isError: false,
			errMsg: '账号或密码错误',
    }
  },
	mounted() {
		// 判断是否登录
		let loginUser = local.get('userInfo')
		if(loginUser){
			this.$router.push('/riderInfo')
		}
	},
  methods: {
    submitForm(){
			this.$refs['loginFormRefs'].validate((valid) => {
				if (valid) {
					let params = {
						userName: this.loginForm.userName,
						password: getrsa(this.loginForm.password)
					}
					login(params).then(res => {
						console.log(res);
						if(res.code == 200) {
							this.isError = false
							local.set('userInfo', res.data)
							this.$router.push('/riderInfo')
						} else {
							this.isError = true
							this.errMsg = res.data
						}
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
    }
  }
}
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: url('../assets/login_bg.png') no-repeat center center/100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.login_wrapper {
  flex: 1;
  position: relative;
}
.login_wrapper h3 {
  margin-bottom: 40px;
}
.main {
  width: 380px;
  height: 380px;
  background: #fff;
  box-shadow: 4px;
  position: absolute;
  top: 100px;
  right: 200px;
  box-sizing: border-box;
  padding: 35px 40px;
}
.login-oper {
  position: absolute;
  bottom: 58px;
  width: 300px;
}
.login-oper p {
  font-size: 16px;
  color: #ED3636;
  margin-bottom: 12px;
}
button {
  width: 100%;
  font-size: 16px;
}
</style>
